import { PayinPaymentMethod } from '~/entities/payin';
import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';
import { type CreateOrderProps } from '../CreateOrder';

const titles = {
    [PayinPaymentMethod.METHOD_SBP]: 'Создание транзакции по сбп',
    [PayinPaymentMethod.METHOD_CARD]: 'Создание транзакции по карте',
};

export const openCreateOrderModal = (props: CreateOrderProps) => {
    openResponsiveModal({
        modalId: MODALS.PAYIN_ORDER_CREATION,
        modal: MODALS.PAYIN_ORDER_CREATION,
        title: titles[props.paymentMethod],
        innerProps: {
            ...props,
            onSuccess: () => {
                closeResponsiveModal(MODALS.PAYIN_ORDER_CREATION);
                props.onSuccess?.();
            },
            onCancel: () => {
                closeResponsiveModal(MODALS.PAYIN_ORDER_CREATION);
            },
        },
    });
};
